import React, { createContext, useContext, useState } from 'react';

const translations = {
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      about: 'À propos',
      fleet: 'Véhicules',
      reviews: 'Avis',
      contact: 'Contact',
    },
    // Hero
    hero: {
      headline: 'Explorez La Marsa en Toute Liberté',
      subheadline: 'Votre partenaire de confiance pour la location de voiture à La Marsa. Service fiable, véhicules modernes, prix transparents.',
      cta_primary: 'Réserver via WhatsApp',
      cta_secondary: 'Voir nos véhicules',
      rating: 'avis Google',
    },
    // About
    about: {
      title: 'À propos de UNI CAR',
      subtitle: 'Votre partenaire de confiance depuis La Marsa',
      description: 'UNI CAR est votre agence de location de voitures de confiance à La Marsa, Tunis. Nous nous engageons à fournir un service de qualité supérieure avec une flotte de véhicules modernes et bien entretenus.',
      features: [
        { title: 'Service Client Exceptionnel', desc: 'Notre équipe multilingue (français, anglais, allemand) est à votre écoute pour répondre à toutes vos questions.' },
        { title: 'Véhicules Propres & Entretenus', desc: 'Tous nos véhicules sont régulièrement entretenus et nettoyés pour votre confort et sécurité.' },
        { title: 'Prix Transparents', desc: 'Pas de frais cachés. Le prix que vous voyez est le prix que vous payez.' },
        { title: 'Processus Simple & Rapide', desc: 'Réservation facile et retrait/retour de véhicule en quelques minutes seulement.' },
      ],
    },
    // Fleet
    fleet: {
      title: 'Notre Flotte',
      subtitle: 'Des véhicules adaptés à tous vos besoins',
      cta: 'Demander un devis',
      features: {
        ac: 'Climatisation',
        manual: 'Boîte manuelle',
        economic: 'Économique',
        seats: 'places',
      },
      price: 'Prix sur demande',
    },
    // Reviews
    reviews: {
      title: 'Avis de nos Clients',
      subtitle: 'Ce que disent nos clients satisfaits',
      rating: 'sur Google',
    },
    // Contact
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes là pour vous aider',
      address: 'Adresse',
      phone: 'Téléphone',
      hours: 'Horaires',
      hoursValue: 'Lundi – Samedi: 08:30 – 18:00',
      form: {
        name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone',
        message: 'Message',
        submit: 'Envoyer',
        success: 'Message envoyé avec succès!',
      },
    },
    // Footer
    footer: {
      description: 'Votre partenaire de confiance pour la location de voiture à La Marsa, Tunis.',
      quickLinks: 'Liens Rapides',
      contact: 'Contact',
      followUs: 'Suivez-nous',
      rights: 'Tous droits réservés.',
    },
    // WhatsApp
    whatsapp: {
      message: 'Bonjour! Je souhaite réserver un véhicule.',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      fleet: 'Vehicles',
      reviews: 'Reviews',
      contact: 'Contact',
    },
    // Hero
    hero: {
      headline: 'Explore La Marsa with Freedom',
      subheadline: 'Your trusted partner for car rental in La Marsa. Reliable service, modern vehicles, transparent pricing.',
      cta_primary: 'Book via WhatsApp',
      cta_secondary: 'View our vehicles',
      rating: 'Google reviews',
    },
    // About
    about: {
      title: 'About UNI CAR',
      subtitle: 'Your trusted partner from La Marsa',
      description: 'UNI CAR is your trusted car rental agency in La Marsa, Tunis. We are committed to providing superior quality service with a fleet of modern and well-maintained vehicles.',
      features: [
        { title: 'Exceptional Customer Service', desc: 'Our multilingual team (French, English, German) is here to answer all your questions.' },
        { title: 'Clean & Maintained Vehicles', desc: 'All our vehicles are regularly maintained and cleaned for your comfort and safety.' },
        { title: 'Transparent Pricing', desc: 'No hidden fees. The price you see is the price you pay.' },
        { title: 'Simple & Fast Process', desc: 'Easy booking and vehicle pick-up/drop-off in just a few minutes.' },
      ],
    },
    // Fleet
    fleet: {
      title: 'Our Fleet',
      subtitle: 'Vehicles adapted to all your needs',
      cta: 'Request a quote',
      features: {
        ac: 'Air Conditioning',
        manual: 'Manual Transmission',
        economic: 'Economic',
        seats: 'seats',
      },
      price: 'Price on request',
    },
    // Reviews
    reviews: {
      title: 'Customer Reviews',
      subtitle: 'What our satisfied customers say',
      rating: 'on Google',
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'We are here to help you',
      address: 'Address',
      phone: 'Phone',
      hours: 'Hours',
      hoursValue: 'Monday – Saturday: 08:30 – 18:00',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send',
        success: 'Message sent successfully!',
      },
    },
    // Footer
    footer: {
      description: 'Your trusted partner for car rental in La Marsa, Tunis.',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      followUs: 'Follow Us',
      rights: 'All rights reserved.',
    },
    // WhatsApp
    whatsapp: {
      message: 'Hello! I would like to book a vehicle.',
    },
  },
  de: {
    // Navigation
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      fleet: 'Fahrzeuge',
      reviews: 'Bewertungen',
      contact: 'Kontakt',
    },
    // Hero
    hero: {
      headline: 'Entdecken Sie La Marsa in Freiheit',
      subheadline: 'Ihr vertrauenswürdiger Partner für Autovermietung in La Marsa. Zuverlässiger Service, moderne Fahrzeuge, transparente Preise.',
      cta_primary: 'Über WhatsApp buchen',
      cta_secondary: 'Unsere Fahrzeuge ansehen',
      rating: 'Google Bewertungen',
    },
    // About
    about: {
      title: 'Über UNI CAR',
      subtitle: 'Ihr vertrauenswürdiger Partner aus La Marsa',
      description: 'UNI CAR ist Ihre vertrauenswürdige Autovermietung in La Marsa, Tunis. Wir bieten erstklassigen Service mit einer Flotte moderner und gut gewarteter Fahrzeuge.',
      features: [
        { title: 'Außergewöhnlicher Kundenservice', desc: 'Unser mehrsprachiges Team (Französisch, Englisch, Deutsch) beantwortet gerne alle Ihre Fragen.' },
        { title: 'Saubere & Gepflegte Fahrzeuge', desc: 'Alle unsere Fahrzeuge werden regelmäßig gewartet und gereinigt für Ihren Komfort und Sicherheit.' },
        { title: 'Transparente Preise', desc: 'Keine versteckten Gebühren. Der Preis, den Sie sehen, ist der Preis, den Sie zahlen.' },
        { title: 'Einfacher & Schneller Prozess', desc: 'Einfache Buchung und Fahrzeugabholung/-rückgabe in nur wenigen Minuten.' },
      ],
    },
    // Fleet
    fleet: {
      title: 'Unsere Flotte',
      subtitle: 'Fahrzeuge für alle Ihre Bedürfnisse',
      cta: 'Angebot anfragen',
      features: {
        ac: 'Klimaanlage',
        manual: 'Schaltgetriebe',
        economic: 'Sparsam',
        seats: 'Sitze',
      },
      price: 'Preis auf Anfrage',
    },
    // Reviews
    reviews: {
      title: 'Kundenbewertungen',
      subtitle: 'Was unsere zufriedenen Kunden sagen',
      rating: 'auf Google',
    },
    // Contact
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir sind für Sie da',
      address: 'Adresse',
      phone: 'Telefon',
      hours: 'Öffnungszeiten',
      hoursValue: 'Montag – Samstag: 08:30 – 18:00',
      form: {
        name: 'Vollständiger Name',
        email: 'E-Mail',
        phone: 'Telefon',
        message: 'Nachricht',
        submit: 'Senden',
        success: 'Nachricht erfolgreich gesendet!',
      },
    },
    // Footer
    footer: {
      description: 'Ihr vertrauenswürdiger Partner für Autovermietung in La Marsa, Tunis.',
      quickLinks: 'Schnelllinks',
      contact: 'Kontakt',
      followUs: 'Folgen Sie uns',
      rights: 'Alle Rechte vorbehalten.',
    },
    // WhatsApp
    whatsapp: {
      message: 'Hallo! Ich möchte ein Fahrzeug buchen.',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translations: translations[language] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
